<template>
  <base-form :title="$t('settings.emailConfiguration.title')"
             @submit="onSubmit">
    <fg-input :label="$t('settings.emailConfiguration.default')">
      <base-switch v-model="model.default">

      </base-switch>
    </fg-input>
    <fg-input :label="$t('settings.emailConfiguration.status')">
      <el-select v-model="model.config_status" class="select-default">
        <el-option v-for="option in statuses"
                   :key="option.label"
                   :label="option.label"
                   :value="option.value"
                   class="select-default">
        </el-option>
      </el-select>
    </fg-input>
    <fg-input :label="$t('settings.emailConfiguration.template')">
      <el-select v-model="model.template"
                 value-key="driver"
                 class="select-default">
        <el-option v-for="option in templates"
                   :key="option.label"
                   :label="option.label"
                   :value="option.value"
                   class="select-default">
        </el-option>
      </el-select>
    </fg-input>
    <fg-input v-model="model.provider_domain"
              placeholder="e.g: exenzo.com"
              :label="$t('settings.emailConfiguration.domain')">
    </fg-input>
    <fg-input v-model="model.provider_host"
              required
              placeholder="e.g: smtp.mailgun.org"
              v-validate="modelValidations.provider_host"
              :label="$t('settings.emailConfiguration.smtp')"
              :name="$t('settings.emailConfiguration.smtp')"
              :error="getError($t('settings.emailConfiguration.smtp'))">
    </fg-input>
    <fg-input v-model="model.provider_username"
              required
              placeholder="e.g: username"
              v-validate="modelValidations.provider_username"
              :label="$t('settings.emailConfiguration.username')"
              :name="$t('settings.emailConfiguration.username')"
              :error="getError($t('settings.emailConfiguration.username'))">
    </fg-input>
    <fg-input v-if="model.id" :label="$t('settings.emailConfiguration.changePassword')">
      <base-switch v-model="showPassword" @input="onShowPasswordChange"></base-switch>
    </fg-input>
    <fg-input v-if="showPassword || !model.id"
              v-model="model.provider_password"
              required
              placeholder="e.g: password"
              type="password"
              v-validate="modelValidations.provider_password"
              :label="$t('settings.emailConfiguration.password')"
              :name="$t('settings.emailConfiguration.password')"
              :error="getError($t('settings.emailConfiguration.password'))">
    </fg-input>
    <fg-input v-model="model.provider_port"
              required
              placeholder="e.g: 587"
              v-validate="modelValidations.provider_port"
              :label="$t('settings.emailConfiguration.port')"
              :name="$t('settings.emailConfiguration.port')"
              :error="getError($t('settings.emailConfiguration.port'))">
    </fg-input>
    <fg-input :label="$t('settings.emailConfiguration.encryption')">
      <el-select v-model="model.provider_encryption" class="select-default">
          <el-option v-for="option in encryptions"
                     :key="option.label"
                     :label="option.label"
                     :value="option.value"
                     class="select-default">
          </el-option>
      </el-select>
    </fg-input>
    <fg-input v-model="model.from_email"
              required
              type="email"
              placeholder="e.g: support@exenzo.com"
              v-validate="modelValidations.from_email"
              :label="$t('settings.emailConfiguration.fromEmail')"
              :name="$t('settings.emailConfiguration.fromEmail')"
              :error="getError($t('settings.emailConfiguration.fromEmail'))">
    </fg-input>
    <fg-input v-model="model.from_name"
              required
              placeholder="e.g: Exenzo support"
              v-validate="modelValidations.from_name"
              :label="$t('settings.emailConfiguration.fromName')"
              :name="$t('settings.emailConfiguration.fromName')"
              :error="getError($t('settings.emailConfiguration.fromName'))">
    </fg-input>

  </base-form>
</template>
<script>
  import { Select, Option } from 'element-ui'
  export default {
    name: 'email-config-form',
    components: {
      [Select.name]: Select,
      [Option.name]: Option,
    },
    props: {
      data: {
        type: Object,
        default: () => ({})
      }
    },
    data() {
      return {
        templates: [
          {
            label: 'Mandrill',
            value: {
              driver: 'mandrill',
              provider_host: 'smtp.mandrillapp.com',
              provider_port: 587,
              provider_encryption: 'tls'
            }
          },
          {
            label: 'Mailgun',
            value: {
              driver: 'mailgun',
              provider_host: 'smtp.mailgun.org',
              provider_port: 587,
              provider_encryption: 'tls'
            }
          },
          {
            label: 'Gmail',
            value: {
              driver: 'gmail',
              provider_host: 'smtp.gmail.org',
              provider_port: 587,
              provider_encryption: 'tls'
            }
          }
        ],
        types: {
          api: {},
          smtp: {}
        },
        statuses: [
          {
            label: this.$t('settings.emailConfiguration.draft'),
            value: 'draft'
          },
          {
            label: this.$t('settings.emailConfiguration.active'),
            value: 'active'
          },
          {
            label: this.$t('settings.emailConfiguration.broken'),
            value: 'broken'
          }
        ],
        encryptions: [
          {
            label: 'TLS',
            value: 'tls'
          },
          {
            label: 'SSL',
            value: 'ssl'
          },
        ],
        showPassword: false,
        model: {
          default: false,
          provider_domain: "",
          provider_host: "smtp.mailgun.org",
          provider_username: "",
          provider_password: "",
          provider_port: 587,
          provider_encryption: "tls",
          from_email: "",
          from_name: "",
          config_status: "draft",
          template: {
            driver: 'mailgun'
          },
          type: "smtp",
          driver: "smtp",
          provider_secret: ""
        }
      }
    },
    computed: {
      modelValidations() {
        return {
          provider_domain: {
            url: true
          },
          provider_host: {
            required: true
          },
          provider_username: {
            required: true
          },
          provider_password: {
            required: true
          },
          provider_port: {
            required: true
          },
          from_email: {
            required: true,
            email: true
          },
          from_name: {
            required: true
          }
        }
      }
    },
    methods: {
      onShowPasswordChange(value) {
        if(value) {
          this.model.provider_password = ''
        }
      },
      async onSubmit () {
        let valid = await this.$validator.validateAll()
        if (!valid) {
          return
        }
        let confirmMessage = this.$t('settings.emailConfiguration.updateConfirm.message')
        if(this.model.provider_password) {
          confirmMessage+= this.$t('settings.emailConfiguration.updateConfirm.message2')
        }
        await this.$confirm(this.$t('settings.emailConfiguration.updateConfirm.title'), {
          dangerouslyUseHTMLString: true,
          message: confirmMessage
        })
        let data = {
          ...this.model,
          template: this.model.template.driver
        }
        this.$emit('submit', data)
      }
    },
    watch: {
      data(newVal) {
        this.model = {
          ...this.model,
          ...newVal,
          template: {
            driver: newVal.template
          },
          provider_password: undefined
        }
      },
      'model.template'(newVal) {
        let { driver, provider_host, provider_encryption } = newVal
        if (!provider_host || !provider_encryption) {
          return
        }
        this.model.driver = driver
        this.model.provider_host = provider_host
        this.model.provider_encryption = provider_encryption
      }
    }
  }
</script>
